import type { ComputedRef } from "vue";
import type { DSFileUploadComponentProps, DSFileUploadItem } from "../types";

interface UseDSFileUploadFieldNamesOptions {
  props: DSFileUploadComponentProps;
  id: ComputedRef<string>;
}

export function useDSFileUploadFieldNames({ props, id }: UseDSFileUploadFieldNamesOptions) {
  function fileFieldName(item: DSFileUploadItem): string {
    return `${fieldRootName()}[${item.id}][file]`;
  }

  function filenameFieldName(item: DSFileUploadItem): string {
    return `${fieldRootName()}[${item.id}][filename]`;
  }

  function fieldRootName(): string {
    return props.name || id.value;
  }

  return {
    fileFieldName,
    filenameFieldName,
  };
}
